import moment from 'moment';
import {Card} from 'primereact/card';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import MenuItemIcon from '../components/MenuItemIcon';
import BlockUi from '../components/waitPanel/BlockUi';
import CardUserService from '../services/CardUserService';
import ImageService from '../services/ImageService';
import CardDataEditDialog from './CardDataEditDialog';
import TransactionListContainer from './TransactionListContainer';
import CardListContainer from './CardListContainer';
import TransactionService from '../services/TransactionService';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import SetPinDialog from './SetPinDialog';
import NumberFormat from 'react-number-format';
import MobileUserRoleDialog from './MobileUserRoleDialog';
import MobileUserAuthorizeDialog from './MobileUserAuthorizeDialog';
import AuthService from '../services/AuthService';

class UserDetailsContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new CardUserService();
        this.imageService = new ImageService();
        this.transactionService = new TransactionService();
        this.authService = new AuthService();
        this.state = {
            activeIndex: 0,
            yourCardCount: 0,
            virtualCardUsersCount: 0,
            stepView: 'LIST',
            element: {},
            cardDataEditDialogVisibile: false,
            mobileUserAuthorizeDialogVisibile: false,
            userAction: undefined,
            allTrxLimitEditionVisibile: false,
            plasticCardPin: '',
            pinEditVisible: false,
            roleEditVisible: false,
            loadingLastTransaction: true,
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleGoToDetail = this.handleGoToDetail.bind(this);
        this.handleOpenCardDataEditDialog = this.handleOpenCardDataEditDialog.bind(this);
        this.handleEditPinOpen = this.handleEditPinOpen.bind(this);
        this.handleEditPinClose = this.handleEditPinClose.bind(this);
        this.handleEditRoleOpen = this.handleEditRoleOpen.bind(this);
        this.handleEditRoleClose = this.handleEditRoleClose.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        if (this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS')) {
            this.transactionService
                .getLastTransactionForPhone(this.props?.params?.num)
                .then((lastTransaction) => {
                    lastTransaction.date = lastTransaction.date ? new Date(lastTransaction.date) : undefined;
                    this.setState({lastTransaction, loadingLastTransaction: false});
                })
                .catch(() => {
                    const {t} = this.props;
                    this.showErrorMessage(t('error.getLastTransactionInfoError'));
                    this.setState({loadingLastTransaction: false});
                });
        } else {
            this.setState({loadingLastTransaction: false});
        }
        let activeIndex = this.readCookie(`user-details-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.setState({activeIndex: parseInt(activeIndex)});
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }


    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`user-details-activeIndex`, this.state.activeIndex);
            }
        );
    }
    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }
    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                    <MobileUserAuthorizeDialog
                        phoneNumber={this.props?.params?.num}
                        userAction={this.state.userAction}
                        onHide={(e) => this.setState({mobileUserAuthorizeDialogVisibile: false})}
                        visible={this.state.mobileUserAuthorizeDialogVisibile}
                        viewMode={'VIEW'}
                        afterSave={(e) => {
                            let status = this.state.userAction === 'AUTHORIZE' ? 'AUTHORIZED' : 'AUTHORIZATION_REVOKED';
                            this.setState((prevState) => ({
                                mobileUserAuthorizeDialogVisibile: false,
                                userAction: undefined,
                                lastTransaction: {
                                    ...prevState.lastTransaction,
                                    status: status,
                                },
                            }));
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        _isMounted={this._isMounted}
                    />
                    <CardDataEditDialog
                        element={this.state.element}
                        onHide={(e) => this.handleCloseEditClientDialog(e)}
                        visible={this.state.cardDataEditDialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                            })
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                    />
                    <SetPinDialog
                        mainRef={this.props.mainRef}
                        phoneNumber={this.props?.params?.num}
                        onHide={() => this.handleEditPinClose()}
                        visible={this.state.pinEditVisible}
                        viewMode={this.state.dialogViewMode}
                        handleSuccess={(res) => {
                            this.handleEditPinClose(() => {
                                this.showSuccessMessage(t('cards.pinChangeSuccess'));
                            });
                        }}
                        handleError={(limit) => {
                            this.handleEditPinClose(() => {
                                this.showErrorMessage(t('error.pinChangeError'));
                            });
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                    {this.state.lastTransaction ? (
                        <MobileUserRoleDialog
                            className='card-list-manage-dialog'
                            mainRef={this.props.mainRef}
                            phoneNumber={this.props?.params?.num}
                            accountRole={this.state.lastTransaction?.accountRole}
                            personName={this.state.lastTransaction?.personName}
                            carRegistration={this.state.lastTransaction?.carRegistration}
                            onHide={() => this.handleEditRoleClose()}
                            visible={this.state.roleEditVisible}
                            handleSuccess={(res) => {
                                this.handleEditRoleClose(() => {
                                    this.setState(
                                        (prevState) => ({
                                            lastTransaction: {
                                                ...prevState.lastTransaction,
                                                personName: res.personName,
                                                carRegistration: res.carRegistration,
                                                accountRole: res.accountRole,
                                            },
                                        }),
                                        () => this.showSuccessMessage(t('cards.roleChangeSuccess'))
                                    );
                                });
                            }}
                            handleError={(limit) => {
                                this.handleEditRoleClose(() => {
                                    this.showErrorMessage(t('error.roleChangeError'));
                                });
                            }}
                            blockUi={this.blockUi}
                            unblockUi={this.unblockUi}
                            _isMounted={this._isMounted}
                        />
                    ) : null}
                    {this.renderDetailsHeader()}
                    <div className='user-details-container'>
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='dashboard-link-container dashboard-link-container-profile'>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                        <Card header={this.renderAvTransactionCountHeader()}>
                                            <BlockUi
                                                tag='div'
                                                blocking={this.state.loadingLastTransaction}
                                                loader={this.loader}
                                                loaderType='small-loader mobile-user-loader'
                                                horizontal
                                            >
                                                {!!this.state.lastTransaction &&
                                                this.state.lastTransaction?.diffMonthCount !== undefined &&
                                                this.state.lastTransaction?.diffMonthCount !== null ? (
                                                    <DivContainer colClass='row trx'>
                                                        <h1 className='avTrx col-4'>{this.state.lastTransaction?.currentCount ?? 0}</h1>
                                                        {this.state.lastTransaction?.diffMonthCount > 0 ? (
                                                            <div className='avTrx-details-box col-8'>
                                                                <span className={'avRelativceTr-plus col-12'}>
                                                                    <MenuItemIcon
                                                                        alt=''
                                                                        className={`icon-svg left`}
                                                                        iconSvg={'ico_up_arrow'}
                                                                    />
                                                                </span>
                                                                <label key='diffMonthCount' className='avTrx-details-label col-12'>
                                                                    {t('cards.userDetails.overLastMonth')}
                                                                </label>
                                                            </div>
                                                        ) : this.state.lastTransaction?.diffMonthCount < 0 ? (
                                                            <div className='avTrx-details-box col-8'>
                                                                <span className={'avRelativceTr-minus col-12'}>
                                                                    <MenuItemIcon
                                                                        alt=''
                                                                        className={`icon-svg left`}
                                                                        iconSvg={'ico_down_arrow'}
                                                                    />
                                                                </span>
                                                                <label key='diffMonthCount' className='avTrx-details-label col-12'>
                                                                    {t('cards.userDetails.underLastMonth')}
                                                                </label>
                                                            </div>
                                                        ) : null}
                                                    </DivContainer>
                                                ) : (
                                                    <DivContainer colClass='row trx'>
                                                        <h1 className='avTrx col-4'>0</h1>
                                                    </DivContainer>
                                                )}
                                            </BlockUi>
                                        </Card>
                                    </DivContainer>
                                    {this.state.lastTransaction?.transactionType !== null &&
                                        this.state.lastTransaction?.transactionType !== undefined &&
                                        this.state.lastTransaction?.transactionType !== 2 ? (
                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                        <Card header={this.renderLastTransactionHeader()}>
                                            <BlockUi
                                                tag='div'
                                                blocking={this.state.loadingLastTransaction}
                                                loader={this.loader}
                                                loaderType='small-loader card-loader'
                                                horizontal
                                            >
                                                <div className='row '>
                                                    {!!this.state.lastTransaction && !!this.state.lastTransaction.date ? (
                                                        <div className='col-12'>
                                                            {this.state.lastTransaction?.positions &&
                                                            this.state.lastTransaction?.positions.length
                                                                ? this.state.lastTransaction?.positions.map((p, index) => {
                                                                      return (
                                                                          <div className='row last-transaction-row'>
                                                                              <h1
                                                                                  id={`last-trx-quantity-${index}`}
                                                                                  className='lastTrx col-6'
                                                                              >
                                                                                  <NumberFormat
                                                                                      value={p.quantity}
                                                                                      displayType={'text'}
                                                                                      thousandSeparator=' '
                                                                                      decimalSeparator=','
                                                                                      fixedDecimalScale
                                                                                      decimalScale={2}
                                                                                      renderText={(value) => value}
                                                                                     // suffix={this.state.lastTransaction?.transactionType === 3 ?  " " +t(`measureUnit.${this.state.lastTransaction?.quantityUnit}`) : ` ${t('cards.l')}`}
                                                                                      suffix={this.renderSuffixForPositionItem(p, index)}
                                                                                  />
                                                                              </h1>
                                                                              <div className='avTrx-details-box col-6 last-transaction fleet-good-group'>
                                                                                  {this.renderItemLastTransaction(p, index)}
                                                                              </div>
                                                                          </div>
                                                                      );
                                                                  })
                                                                : null}
                                                            <label className='avTrx-details-label' key='lastTransaction-date'>
                                                                {this.state.lastTransaction?.date &&
                                                                moment.isDate(this.state.lastTransaction?.date)
                                                                    ? moment(this.state.lastTransaction?.date).format('DD.MM.YYYY')
                                                                    : ''}
                                                                , {this.state.lastTransaction?.stationName}
                                                            </label>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </BlockUi>
                                        </Card>
                                    </DivContainer> ) :

(
    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
        <Card header={this.renderLastTransactionHeader()}>
            <BlockUi
                tag='div'
                blocking={this.state.loadingLastTransaction}
                loader={this.loader}
                loaderType='small-loader card-loader'
                horizontal
            >
                <div className='row '>
                    {!!this.state.lastTransaction && !!this.state.lastTransaction.date ? (
                        <div className='col-12'>
                            {this.state.lastTransaction?.transactionType === 2 ? (
                                <div className='row last-transaction-row'>
                                    <h1 id={`last-trx-quantity-ev`} className='lastTrx col-6'>
                                        <NumberFormat
                                            value={this.state.lastTransaction?.evQuantity}
                                            displayType={'text'}
                                            thousandSeparator=' '
                                            decimalSeparator=','
                                            fixedDecimalScale
                                            decimalScale={2}
                                            renderText={(value) => value}
                                            suffix={` ${this.state.lastTransaction?.quantityUnit}`}
                                        />
                                    </h1>
                                    <div className='avTrx-details-box col-6 last-transaction fleet-good-group'>
                                        {this.renderItemLastTransaction(
                                            this.state.lastTransaction,
                                            'ev'
                                        )}
                                    </div>
                                </div>
                            ) : null}
                            <label className='avTrx-details-label' key='lastTransaction-date'>
                                {this.state.lastTransaction?.date &&
                                moment.isDate(this.state.lastTransaction?.date)
                                    ? moment(this.state.lastTransaction?.date).format('DD.MM.YYYY')
                                    : ''}
                                , {this.state.lastTransaction?.stationName}
                            </label>
                        </div>
                    ) : null}
                </div>
            </BlockUi>
        </Card>
    </DivContainer>
)}
                                    
                                    <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                        <Card className='banner-card'>
                                            <img
                                                alt={t('card.banner.alt')}
                                                src={
                                                    this.state.bannerImage ? `/images/${this.state.bannerImage}` : '/images/card_banner.png'
                                                }
                                                className='banner-user-image'
                                            />
                                        </Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>

                        {this.state.stepView === 'LIST' ? (
                            <React.Fragment>
                                <CardListContainer
                                    embedded
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    _isMounted={this._isMounted}
                                    showMessage={this.showMessage}
                                    phoneNumber={this.props?.params?.num}
                                    cardTypePanels={true}
                                    handleGoToDetail={() => this.handleGoToDetail}
                                />
                                {this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS') && (
                                    <TransactionListContainer
                                        embedded
                                        blockUi={this.blockUi}
                                        unblockUi={this.unblockUi}
                                        _isMounted={this._isMounted}
                                        showMessage={this.showMessage}
                                        phoneNumber={this.props?.params?.num}
                                    />
                                )}
                            </React.Fragment>
                        ) : (
                            this.renderCardData()
                        )}
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
    renderBackLink(label, handleBack) {
        return (
            <ActionLink
                label={label}
                className='back-blue-link'
                handleClick={handleBack}
                variant='blue'
                iconName='mdi-arrow-left left-arrow-style'
                iconSide='left'
                iconSize='xs'
                iconColor='blue'
            />
        );
    }

    renderItemLastTransaction(p, index) {
        const {t} = this.props;
        const color = p.color ? p.color : 'white';
        const fontColor = p.color ? 'white' : '#090E22';
        return (
            <label
                key={`last-transaction-${p.name}-${index}`}
                id={`last-transaction-${p.name}-${index}`}
                className={`product-label card-details ${p.color ? 'gray-border' : 'transparent-border product-not-fuel-label'}`}
                style={{backgroundColor: `${color}`, color: `${fontColor}`}}
            >
                {p.transactionType === 2 ? p.evName : t(`products.${p.name}`)}
            </label>
        );
    }

    renderDetailsHeader() {
        if (this.state.stepView === 'LIST') {
            return this.renderUserDetailsHeader();
        } else return this.renderCardDetailsHeader();
    }
    handleEditPinOpen() {
        this.setState({pinEditVisible: true});
    }
    handleEditPinClose(callback) {
        this.setState({pinEditVisible: false}, () => {
            if (callback) {
                callback();
            }
        });
    }
    handleEditRoleOpen() {
        this.setState({roleEditVisible: true});
    }
    handleEditRoleClose(callback) {
        this.setState({roleEditVisible: false}, () => {
            if (callback) {
                callback();
            }
        });
    }
    renderUserDetailsHeader() {
        const {t} = this.props;
        return (
            <div className=''>
                <div className='user-details-header'>
                    <div className='row'>
                        <div className='card-photo-container col-width-auto'>
                            <MenuItemIcon alt='' className={`icon-svg left profile-big-icon`} iconSvg={'ico_big_user'} />
                        </div>
                        <div className='card-info-container col-width-flex'>
                            <div className='row profile'>
                                <label className='card-info-label col-12'>{`${this.props?.params?.num}`}</label>
                            </div>
                            <BlockUi
                                tag='div'
                                blocking={this.state.loadingLastTransaction}
                                loader={this.loader}
                                loaderType='small-loader mobile-user-loader'
                                horizontal
                            >
                                <div className='col-12'>
                                    <div className='row'>
                                        <InputTextComponent
                                            id='cardCount'
                                            name='cardCount'
                                            label={t('cards.cardCount')}
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value={this.state.lastTransaction?.cardsCount}
                                            viewMode={'VIEW'}
                                        />

                                        <InputCalendarComponent
                                            id='createDate'
                                            name='createDate'
                                            label={t('cards.mobileUserCreateDate')}
                                            dateFormatMoment='DD-MM-YYYY'
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value={this.state.lastTransaction?.createDate}
                                            viewMode={'VIEW'}
                                            showIcon
                                        />
                                        <InputTextComponent
                                            id='pin'
                                            name='pin'
                                            label={t('cards.pinLabelUserDetailsHeader')}
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value=''
                                            viewMode={'VIEW'}
                                            renderValue={() => {
                                                return (
                                                    <span>
                                                        ****
                                                        {this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') && (
                                                            <MenuItemIcon
                                                                alt=''
                                                                className={`icon-svg right`}
                                                                iconSvg={'ico_pencil'}
                                                                handleClick={this.handleEditPinOpen}
                                                            />
                                                        )}
                                                    </span>
                                                );
                                            }}
                                        />
                                        <InputTextComponent
                                            id='accountRole'
                                            name='accountRole'
                                            label={t('cards.role')}
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value={
                                                this.state.lastTransaction?.accountRole
                                                    ? t(`AccountRole.${this.state.lastTransaction?.accountRole}`)
                                                    : '-'
                                            }
                                            viewMode={'VIEW'}
                                        />
                                        <InputTextComponent
                                            id='personName'
                                            name='personName'
                                            label={t('cards.personName')}
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value={this.state.lastTransaction?.personName ? this.state.lastTransaction?.personName : '-'}
                                            viewMode={'VIEW'}
                                        />
                                        <InputTextComponent
                                            id='carRegistration'
                                            name='carRegistration'
                                            label={t('cards.carRegistration')}
                                            colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                                            value={
                                                this.state.lastTransaction?.carRegistration
                                                    ? this.state.lastTransaction?.carRegistration
                                                    : '-'
                                            }
                                            viewMode={'VIEW'}
                                        />
                                    </div>
                                </div>
                            </BlockUi>
                        </div>
                        <div className='col-width-auto button-column'>
                            <ActionButton
                                label={t('details.editButton')}
                                variant='button lock-card-button blue'
                                rendered={!this.state.loadingLastTransaction && this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                handleClick={(e) => {
                                    e.preventDefault();
                                    this.handleEditRoleOpen();
                                }}
                            />
                            <ActionButton
                                label={t('cards.userDetails.unauthorizeButton')}
                                variant='button renew-card-button fullred'
                                rendered={!this.state.loadingLastTransaction && this.state.lastTransaction?.status === 'AUTHORIZED' && this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                handleClick={(e) => {
                                    e.preventDefault();
                                   
                                    this.setState({mobileUserAuthorizeDialogVisibile: true, userAction: 'UNAUTHORIZE'});
                                }}
                            />
                            <ActionButton
                                label={t('cards.userDetails.authorizeButton')}
                                variant='button renew-card-button fullred'
                                rendered={
                                    !this.state.loadingLastTransaction &&
                                    this.state.lastTransaction?.status === 'AUTHORIZATION_REVOKED' &&
                                    this.state.lastTransaction?.accountRole === 'ADMIN' &&
                                    this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')
                                }
                                handleClick={(e) => {
                                    e.preventDefault();
                                    this.setState({mobileUserAuthorizeDialogVisibile: true, userAction: 'AUTHORIZE'});
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderCardDetailsHeader() {
        const {t} = this.props;
        return (
            <div className=''>
                <div className='user-details-header'>
                    <div className='row'>
                        <div className='card-photo-container'>
                            <img
                                alt={t('card.photo.alt')}
                                src={
                                    this.authService.getProfile().agreementType === 'CASH'
                                        ? `/images/card_header_cash_new.png`
                                        : '/images/card_header_cashless_new.png'
                                }
                                className='header-card-image'
                            />
                        </div>
                        <div className='card-info-container'>
                            <div className='row profile'>
                                {/* todo własciwy nr */}
                                <label className='card-info-label col-12'>{`${t('cards.cardDetailsHeader')} *38101000003`}</label>
                            </div>
                            <div className='row'>
                                <InputTextComponent
                                    id='cardKind'
                                    name='cardKind'
                                    label={t('cards.cardKind')}
                                    colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                                    value={t(`EcCardKind.${this.state.cardKind}`)}
                                    viewMode={'VIEW'}
                                />
                                <InputTextComponent
                                    id='allTransactionsLimit'
                                    name='allTransactionsLimit'
                                    label={t('order-card.monthlyAmountLimitSummary')}
                                    colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                                    value={this.state.allTransactionsLimit}
                                    renderValue={() => {
                                        return (
                                            <span>
                                                {this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') && (
                                                    <MenuItemIcon
                                                        alt=''
                                                        className={`icon-svg right`}
                                                        iconSvg={'ico_pencil'}
                                                        handleClick={this.handleAllTrxEditionOpen}
                                                    />
                                                )}
                                            </span>
                                        );
                                    }}
                                    viewMode={'VIEW'}
                                />
                                <InputTextComponent
                                    id='plasticCardPin'
                                    name='plasticCardPin'
                                    label={t('cards.plasticCardPin')}
                                    colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                                    value={this.state.plasticCardPin}
                                    viewMode={'VIEW'}
                                    renderValue={() => {
                                        return (
                                            <span>
                                                {this.state.plasticCardPin}
                                                <MenuItemIcon alt='' className={`icon-svg right`} iconSvg={'ico_pencil'} />
                                            </span>
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderCardData() {
        const {t} = this.props;
        return (
            <DivContainer colClass='dashboard'>
                <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                    <DivContainer colClass='row'>
                        <DivContainer colClass='col-12'>
                            <Card header={this.renderCardDataHeader()}>
                                <div className='row profile'>
                                    <InputTextComponent
                                        id='phoneNumber'
                                        name='phoneNumber'
                                        label={t('cards.phoneNumber')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.phoneNumber}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='fullName'
                                        name='fullName'
                                        label={t('cards.fullName')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.fullName}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='registrationNumber'
                                        name='registrationNumber'
                                        label={t('cards.registrationNumberFull')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.registrationNumber}
                                        viewMode={'VIEW'}
                                    />
                                </div>
                                <div className='row profile'>
                                    <InputTextComponent
                                        id='odometer'
                                        name='odometer'
                                        label={t('cards.odometer')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.odometer}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='mpk'
                                        name='mpk'
                                        label={t('cards.mpk')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.mpk}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='additionalInfo'
                                        name='additionalInfo'
                                        label={t('cards.additionalInfo')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        value={this.state.element.additionalInfo}
                                        viewMode={'VIEW'}
                                    />
                                </div>
                                <div className='row profile edit'>
                                    <ActionButton
                                        label={t('details.editButton')}
                                        variant='editButton white'
                                        handleClick={this.handleOpenCardDataEditDialog}
                                        iconSvg='ico_pencil'
                                        iconSide='left'
                                        disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                    />
                                </div>
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </DivContainer>
        );
    }
    handleGoToDetail(e, rowData, x) {
        if (e) {
            e.preventDefault();
        }
        this.setState({stepView: 'DETAILS', element: rowData});
    }
    renderAvTransactionCountHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: `${t('cards.avTransactionCountHeader')}${t(`months.${new Date().getMonth()}`)}`,
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderLastTransactionHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('cards.lastTransactionHeader'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderCardDataHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('cards.userDetails.cardData'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderSuffixForPositionItem(p, index) {
        const { t } = this.props;
        if (p.measureUnit !== null && p.measureUnit !== undefined) {
            return " " + t(`measureUnit.${p.measureUnit}`)
        } else {
            return ` ${t('cards.l')}`
        }

    }

    handleOpenCardDataEditDialog() {
        this.setState({cardDataEditDialogVisibile: true});
    }
    handleCloseEditClientDialog(e, callback) {
        this.setState({cardDataEditDialogVisibile: false}, () => {
            if (callback) {
                callback();
            }
        });
    }
}
UserDetailsContainer.defaultProps = {
    backUrl: '#/cards',
};

UserDetailsContainer.propTypes = {};
export default withTranslation()(UserDetailsContainer);
